import React from 'react';
import PropTypes from 'prop-types';

const ComparePopupTop = ({ titleLabel, onClosePopup }) => (
  <section className='ken-compare__popup__top'>
    <button
      type='button'
      className='ken-wrapper--big-grid'
      onClick={onClosePopup}
    >
      <span>{titleLabel}</span>
      <i />
    </button>
  </section>
);

ComparePopupTop.propTypes = {
  titleLabel: PropTypes.string.isRequired,
  onClosePopup: PropTypes.func.isRequired,
};

ComparePopupTop.defaultProps = {};

export default ComparePopupTop;
